import { FC, HTMLAttributes, ReactNode } from 'react';

export type CardProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
  /** Placement only: the surface, border, radius and padding are the card's. */
  className?: string;
};

/**
 * The one card. Variants appear only when a real consumer needs one.
 *
 * Standard `div` attributes (a `data-*` test hook, an `aria-*` label) pass
 * through, so a page can keep the primitive and still name the element.
 */
const Card: FC<CardProps> = ({ children, className, ...rest }) => (
  <div {...rest} className={['ui-card', className].filter(Boolean).join(' ')}>
    {children}
  </div>
);

export default Card;
